import type { Locales } from '../types'
import alertMessages from './messagesAlerts'
import defaultMessages from './messagesDefault'

export default (messages: { [key in Locales]: any }, locale: Locales) => {
  return { ...defaultMessages[locale], ...alertMessages[locale], ...messages[locale] }
}

export * from './messagesAlerts'
